import { useEffect, useState } from "react";
import { Dots } from "../../Components/LoadingAnimations/LoadingAnimations";
import instance from "../../Interceptor/api_instance";
import { useAuth } from "../../Auth/AuthProvider";
import { useTranslation } from "react-i18next";
import { ActionResponse } from "../../Components/Modals/ActionResponses";

export const CheckOutVisitor = ({ onClose, visitor }) => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const [imgUrls, setImgUrls] = useState([]);
  const [loadingImg, setLoadingImg] = useState(false);
  const [selectedImg, setSelectedImg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [responseModal, setResponseModal] = useState(null);
  const [employeePin, setEmployeePin] = useState("");

  useEffect(() => {
    const fetchImages = async () => {
      setLoadingImg(true);

      const data = await instance.get(`assets/get-entry-images/${visitor.id}`);
      if (data.data !== "") {
        setImgUrls(data.data.img_urls);
      }
      setLoadingImg(false);
    };
    fetchImages();
  }, [visitor]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const data = {
        id: visitor.visitor.id,
        employee_pin: employeePin
      };
      const response = await instance.post("assets/check-out-visitor/", data);
      if (response.status === 200) {
        setResponseModal({
          message: t("forms.responses.success"),
          status: t("forms.type.success"),
        });
      }
    } catch (error) {
      console.log(error);
      setResponseModal({
        message: error,
        status: "Error",
      });
    } finally {
      setLoading(false);
    }
  };

  const openModal = (image) => setSelectedImg(image);
  const closeModal = () => setSelectedImg(null);

  return (
    <div className="white-cont">
      {responseModal && (
        <ActionResponse
          message={responseModal.message}
          status={responseModal.status}
          close={
            responseModal.status === t("forms.type.success")
              ? () => window.location.reload()
              : () => setResponseModal(null)
          }
        />
      )}
      <h2 className="global-h2 light-black">
        {t("forms.type.check-out-confirm")} {visitor.visitor.first_name}{" "}
        {visitor.visitor.last_name}?
      </h2>
      <div className="driver-photo-id">
        <h2 className="edit-header">
          {t("forms.type.newDriver.input-headers.photo")}
        </h2>
        <div data-testid="profile-photo" className="visitor-photo">
          {loadingImg ? (
            <Dots />
          ) : (
            <div className="visitor-photo-cont">
              {imgUrls.length > 0 ? (
                imgUrls.map((image, index) => (
                  <img
                    alt="visitor imgs"
                    src={image}
                    key={index}
                    onClick={() => openModal(image)}
                    style={{ cursor: "pointer" }}
                  />
                ))
              ) : (
                <p>No images found for this visitor</p>
              )}
            </div>
          )}
        </div>
      </div>
      <form onSubmit={submit}>
        {user.location.loc_country === "Mexico" && (
          <div className="prompt-btns margin-bottom-24">
            <input
              type="password"
              className="text-input-sm"
              placeholder="Pin #"
              value={employeePin}
              onChange={e => setEmployeePin(e.target.value)}
              required
            />
          </div>
        )}
        <div className="prompt-btns">
          {loading ? (
            <Dots />
          ) : (
            <div style={{ display: "flex", gap: "24px" }}>
              <button className="change-pwd-btn" type="submit">
                {t("buttons.check-out")}
              </button>
              <button className="cancel-btn" type="button" onClick={onClose}>
                {t("buttons.cancel")}
              </button>
            </div>
          )}
        </div>
      </form>
      {selectedImg && (
        <div style={{ zIndex: "7" }} className="enlarged-modal">
          <div className="img-cont">
            <img src={selectedImg} alt="Expanded view" />
          </div>
          <div className="btn-cont">
            <button className="close-btn" onClick={closeModal}>
              {t("buttons.back")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
